module.exports = __webpack_public_path__ + "img/cooperate_qy_16@2x.047f12be.png";